import { render, staticRenderFns } from "./Grammar.vue?vue&type=template&id=18fdedcc&scoped=true&"
import script from "./Grammar.vue?vue&type=script&lang=js&"
export * from "./Grammar.vue?vue&type=script&lang=js&"
import style0 from "./Grammar.vue?vue&type=style&index=0&id=18fdedcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fdedcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
